import { compose } from 'ramda';
import { lifecycle } from 'recompose';

import { logNotFoundError } from 'app/error/actions';
import InternalErrorRedirect from 'app/router/InternalErrorRedirect';
import { notFoundRoute } from 'app/router/actions';
import withDispatchOnMount from 'app/enhancers/withDispatchOnMount';

const NotFound = compose(
  withDispatchOnMount(notFoundRoute),
  lifecycle({
    componentDidMount() {
      logNotFoundError();
    },
  }),
)(InternalErrorRedirect);

export default NotFound;
